import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { faTicket } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { ROUTE_CONFIG } from "@/routes/config";

import { TicketCounts } from "../utils/support-dashboard.utils";

/**
 * The "Open tickets" cell (mockup inset, PREC-3939 decision 8): the open count linking into the
 * queue pre-filtered to the company, with the red pill when something waits on us.
 */
export const OpenTicketsCell: FunctionComponent<{ companyId: number; counts?: TicketCounts }> = ({
	companyId,
	counts,
}) => {
	const { t } = useTranslation();

	if (!counts || counts.open === 0) {
		return <span className="text-sm text-text-meta">0</span>;
	}

	return (
		<Link
			className="inline-flex items-center gap-2 text-sm font-semibold text-brand-light hover:underline"
			to={`${ROUTE_CONFIG.TICKETS}?companyId=${companyId}`}
		>
			<Icon icon={faTicket} />
			{counts.open}
			{counts.waitingOnUs > 0 && (
				<span className="inline-flex h-5 items-center rounded-md bg-status-error-light px-1.5 text-[11px] font-medium text-status-error">
					{t("supportDashboard.columns.waitingOnUs", { n: counts.waitingOnUs })}
				</span>
			)}
		</Link>
	);
};
